import React from 'react';

const IconHelpWhatsApp = () => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.04 2.5c-5.24 0-9.5 4.24-9.5 9.46 0 1.67.44 3.3 1.28 4.74L2.5 21.5l4.94-1.29a9.53 9.53 0 0 0 4.6 1.17h.01c5.24 0 9.5-4.24 9.5-9.46 0-2.53-.99-4.9-2.79-6.69a9.47 9.47 0 0 0-6.72-2.73Zm0 17.3h-.01a7.9 7.9 0 0 1-4.02-1.1l-.29-.17-2.93.77.78-2.85-.19-.29a7.85 7.85 0 0 1-1.21-4.2c0-4.34 3.54-7.87 7.9-7.87 2.11 0 4.09.82 5.58 2.31a7.83 7.83 0 0 1 2.31 5.57c0 4.34-3.55 7.83-7.92 7.83Z'
      fill='#17C981'
    />
    <path
      d='M16.38 14.02c-.24-.12-1.41-.69-1.63-.77-.22-.08-.38-.12-.54.12-.16.24-.62.77-.76.93-.14.16-.28.18-.52.06-.24-.12-1.01-.37-1.92-1.18-.71-.63-1.19-1.4-1.33-1.64-.14-.24-.01-.37.11-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.29-.74-1.77-.19-.46-.39-.4-.54-.41h-.46c-.16 0-.42.06-.64.3-.22.24-.84.82-.84 1.99s.86 2.31.98 2.47c.12.16 1.69 2.58 4.1 3.62.57.25 1.02.39 1.37.5.58.18 1.1.16 1.51.1.46-.07 1.41-.58 1.61-1.13.2-.55.2-1.03.14-1.13-.06-.1-.22-.16-.46-.28Z'
      fill='#17C981'
    />
  </svg>
);

export default IconHelpWhatsApp;
